export enum CurrentMode {
  schedule,
  calendar
}

export enum TimeStatus {
  today,
  currentMonth,
  notCurrentMonth
}

export enum ChooseType {
  back = -1,
  go = 1
}

export interface ModalPosition {
  left: number;
  top: number;
  itemLength?: number;
}

export const ModalWidth = 300;

export enum CurrentStatus {
  end = 'end'
}
